import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      finance: {
        available_payment_systems: {
          group_settings: {
            header: 'HEADER',
            group_name: 'GROUP_NAME',
            countries_list: 'COUNTRIES_LIST',
            configure_fields: 'CONFIGURE_FIELDS',
            required_field: 'REQUIRED_FIELD',
            max_length: 'MAX_LENGTH',
            min_length: 'MIN_LENGTH',
            save_button: 'SAVE_BUTTON',
            back_button: 'BACK_BUTTON',
          },
        },
      },
    },
  }));
}
